// import { useState } from 'react'
// import heroImg from './assets/hero.png'
// import reactLogo from './assets/react.svg'
// import viteLogo from './assets/vite.svg'
// import './App.css'

// function App() {
//   const [count, setCount] = useState(0)

//   return (
//     <>
//       <section id="center">
//         <div className="hero">
//           <img src={heroImg} className="base" width="170" height="179" alt="" />
//           <img src={reactLogo} className="framework" alt="React logo" />
//           <img src={viteLogo} className="vite" alt="Vite logo" />
//         </div>
//         <div>
//           <h1>Get started</h1>
//           <p>
//             Edit <code>src/App.jsx</code> and save to test <code>HMR</code>
//           </p>
//         </div>
//         <button
//           type="button"
//           className="counter"
//           onClick={() => setCount((count) => count + 1)}
//         >
//           Count is {count}
//         </button>
//       </section>

//       <div className="ticks"></div>

//       <section id="next-steps">
//         <div id="docs">
//           <svg className="icon" role="presentation" aria-hidden="true">
//             <use href="/icons.svg#documentation-icon"></use>
//           </svg>
//           <h2>Documentation</h2>
//           <p>Your questions, answered</p>
//           <ul>
//             <li>
//               <a href="https://vite.dev/" target="_blank">
//                 <img className="logo" src={viteLogo} alt="" />
//                 Explore Vite
//               </a>
//             </li>
//             <li>
//               <a href="https://react.dev/" target="_blank">
//                 <img className="button-icon" src={reactLogo} alt="" />
//                 Learn more
//               </a>
//             </li>
//           </ul>
//         </div>
//         <div id="social">
//           <svg className="icon" role="presentation" aria-hidden="true">
//             <use href="/icons.svg#social-icon"></use>
//           </svg>
//           <h2>Connect with us</h2>
//           <p>Join the Vite community</p>
//           <ul>
//             <li>
//               <a href="https://github.com/vitejs/vite" target="_blank">
//                 <svg
//                   className="button-icon"
//                   role="presentation"
//                   aria-hidden="true"
//                 >
//                   <use href="/icons.svg#github-icon"></use>
//                 </svg>
//                 GitHub
//               </a>
//             </li>
//             <li>
//               <a href="https://chat.vite.dev/" target="_blank">
//                 <svg
//                   className="button-icon"
//                   role="presentation"
//                   aria-hidden="true"
//                 >
//                   <use href="/icons.svg#discord-icon"></use>
//                 </svg>
//                 Discord
//               </a>
//             </li>
//             <li>
//               <a href="https://x.com/vite_js" target="_blank">
//                 <svg
//                   className="button-icon"
//                   role="presentation"
//                   aria-hidden="true"
//                 >
//                   <use href="/icons.svg#x-icon"></use>
//                 </svg>
//                 X.com
//               </a>
//             </li>
//             <li>
//               <a href="https://bsky.app/profile/vite.dev" target="_blank">
//                 <svg
//                   className="button-icon"
//                   role="presentation"
//                   aria-hidden="true"
//                 >
//                   <use href="/icons.svg#bluesky-icon"></use>
//                 </svg>
//                 Bluesky
//               </a>
//             </li>
//           </ul>
//         </div>
//       </section>

//       <div className="ticks"></div>
//       <section id="spacer"></section>
//     </>
//   )
// }

// export default App

import "./App.css";
import "./des.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";
import SpinnerReducer from "./Components/Reducer/SpinnerReducer";
import Loader from "./Components/CommonServices/Loader";
import GetTokenReducer from "./Components/Reducer/TokenDetailsformLogin";
import React, { useEffect } from "react";
import LandingPage from "./LandingPage";
import Swal from "sweetalert2";
import SwarnandhraLogin from "./Components/SwarnandhraLogin";
import Forgotpassword from "./Components/Forms/Forgotpassword";
import SwarnandhraContactPage from "./Components/KpiReports/SwarnandhraContactPage";
import FeedbackForm from "./Components/KpiForms/FeedbackForm";
// import { runAutoPdfScheduler } from "./Components/KpiForms/AutoPdfScheduler";

const reducer = combineReducers({
  spinner: SpinnerReducer,
  gettokenreducer: GetTokenReducer,
});

const PrivateRoute = ({ element: Element }) => {
  return localStorage.getItem("token") ? (
    <Element />
  ) : (
    Swal.fire({
      text: "You have Successfully Logged Out",
      icon: "success",
      confirmButtonText: "Ok",
    }).then(() => {
      window.location.href = "/SwarnandhraLogin";
    })
  );
};

const store = createStore(reducer, applyMiddleware(thunk));

export { store };

function App() {
  useEffect(() => {
    const handleDrop = (e) => {
      if (["INPUT", "TEXTAREA"].includes(e.target.tagName)) {
        e.preventDefault();
      }
    };

    const handleDragOver = (e) => {
      if (["INPUT", "TEXTAREA"].includes(e.target.tagName)) {
        e.preventDefault();
      }
    };
    document.addEventListener("drop", handleDrop);
    document.addEventListener("dragover", handleDragOver);

    return () => {
      document.removeEventListener("drop", handleDrop);
      document.removeEventListener("dragover", handleDragOver);
    };
  }, []);

  // useEffect(() => {
  //   console.log("App loaded. Starting PDF scheduler.");

  //   // Execute immediately
  //   runAutoPdfScheduler();

  //   // Execute every 30 minutes
  //   const intervalId = setInterval(() => {
  //     runAutoPdfScheduler();
  //   }, 30 * 60 * 1000);

  //   return () => clearInterval(intervalId);
  // }, []);

  return (
    <Provider store={store}>
      <Loader />
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/SwarnandhraLogin" />} />
            <Route path="/SwarnandhraLogin" element={<SwarnandhraLogin />} />
            <Route path="/contact" element={<SwarnandhraContactPage />} />
            <Route path="/Home" element={<SwarnandhraLogin />} />
            <Route
              path="/*"
              element={<LandingPage PrivateRoute={PrivateRoute} />}
            />
            <Route path="*" element={<Navigate to="/SwarnandhraLogin" />} />
            <Route path="/Forgotpassword" element={<Forgotpassword />} />
            <Route path="/feedbackForming" element={<FeedbackForm />} />
          </Routes>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
